<template>
  <div
    v-if="alertMessage"
    class="flex items-center pin-t pin-l w-screen top-alert min-h-11 px-m"
  >
    <ExclamationPoint class="mr-2" />
    <span class="text-red text-xl">{{ alertMessage }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ExclamationPoint from './icons/ExclamationPoint.vue';

export default {
  name: 'TheTopAlert',
  components: {
    ExclamationPoint,
  },
  computed: mapState(['alertMessage']),
};
</script>

<style lang="scss" scoped>
.top-alert {
  background-color: rgba(255, 179, 179, 0.4);
  padding-top: 9px;
  padding-bottom: 9px;
}
</style>
